export default {
  jumpTo(path,v) {
    v.$router.push(path);
  },
}